import React, { useState } from 'react';
import HamburgerMenu from './HamburgerMenu';
import '../styles/MobileHeader.css';
import { useLanguage } from '../contexts/LanguageContext';

// Einheitliches Logo für alle Themes
const LOGO = {
  src: '/images/LogoNew.png',
  alt: 'MyBoki Logo',
};

const MobileHeader = ({
                        onAddBookmark,
                        onModeChange,
                        forceOnlineMode,
                        apiAvailable,
                        onImportClick,
                        premiumUser = false,
                        bookmarks = [],
                        onOpenPanel,
                        onOpenRecipePanel,
                        activeTab = 'bookmarks',
                        activeRecipePanel = null,
                      }) => {
  const { t } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);

  // Dynamic title based on active tab or recipe panel
  const getTitle = () => {
    // Check recipe panels first
    if (activeRecipePanel === 'quick-shopping-list') {
      return t('quickList.title') || 'Heute einkaufen';
    }
    if (activeRecipePanel === 'shopping-list') {
      return t('nav.allLists') || 'Alle Listen';
    }
    if (activeRecipePanel === 'recipes') {
      return t('nav.recipes') || 'Rezepte';
    }

    // Then check tabs
    switch (activeTab) {
      case 'bookmarks': return t('menu.bookmarks') || 'Lesezeichen';
      case 'reminders': return t('menu.reminders') || 'Erinnerungen';
      default: return 'MyBoki.Me';
    }
  };

  return (
      <header className="mobile-header app-bar">
        <div className="header-content">
          {/* Left: Logo (compact) */}
          <div className="header-left">
            <div className="header-logo-compact">
              <img
                  src={LOGO.src}
                  alt={LOGO.alt}
                  className="logo-image-compact"
                  loading="eager"
                  decoding="async"
              />
            </div>
          </div>

          {/* Center: Title */}
          <div className="header-center">
            <h1 className="app-bar-title">{getTitle()}</h1>
          </div>

          {/* Right: Overflow Menu (opens Hamburger) */}
          <div className="header-right">
            <HamburgerMenu
                onModeChange={onModeChange}
                forceOnlineMode={forceOnlineMode}
                apiAvailable={apiAvailable}
                onImportClick={onImportClick}
                premiumUser={premiumUser}
                bookmarks={bookmarks}
                onOpenPanel={onOpenPanel}
                onOpenRecipePanel={onOpenRecipePanel}
            />
          </div>
        </div>
      </header>
  );
};

export default MobileHeader;
